import { createFileRoute, redirect } from '@tanstack/react-router'
import { assetQuery } from '../../data/assets.ts'

export const Route = createFileRoute('/_app/impacts')({
	beforeLoad: async ({ context: { queryClient, impersonation, sub } }) => {
		if (!sub.features.includes('protections') && !impersonation) {
			throw redirect({ to: '/' })
		}
		await queryClient.ensureQueryData(assetQuery(impersonation))
	},
})
